//FIXME - RENAME TO init.js

import Vue from "vue";
import VueRouter from "vue-router";

import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";

import App from "./App.vue";

import db from "./db.js";
import util from "./util.js";
import categoryUtil from "./categoryUtil.js";
import eventHub from "./eventHub.js";
import auth from "./auth.js";
import router from "./router.js";

if (process.env === "production") {
  Vue.use(VueRouter);
  Raven.config("https://aa25107a6096406abe79f22d104af9a8@sentry.io/147119", {
    environment: window.location.hostname == "localhost" ? "dev" : "prod",
    release: `${process.env.GITHASH}`,
  })
    .addPlugin(RavenVue, Vue)
    .install();
}

var currentDay = util.getCurrentDay();
var intervalId = setInterval(dayCheck, 30000); //FIXME - Do this more eloquently, please

var app = new Vue({
  el: "#app",
  data: {
    categories: {},
    settings: {},
    days: {},
  },
  render(createElement) {
    return createElement(App, {
      props: {
        categories: this.categories,
        settings: this.settings,
        days: this.days,
      },
    });
  },
  created() {
    eventHub.$on("user-db-ready", db.loadUserData);
  },
  router,
});

db.setVueInstance(app);
categoryUtil.setVueInstance(app);

//FIXME - This should be done in a better way, probably not with refresh, and more eloquently than
//        setting a timeout/interval
//
//        https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
//        Change timeout to update each time the window regains focus
function dayCheck() {
  if (currentDay != util.getCurrentDay()) {
    //FIXME - Don't touch anything if we're offline!
    //FIXME - Actually move the blocks/associated data on the Vue instance
    window.location.reload();
  }
}

//FIXME - Move this somewhere else
String.prototype.hashCode = function() {
  var hash = 0,
    i,
    chr,
    len;
  if (this.length === 0) return hash;
  for (i = 0, len = this.length; i < len; i++) {
    chr = this.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

/*window.onbeforeunload = function(e) {
  console.warn("BEFOREUNLOAD", e, moment().calendar());
};
window.onunload = function(e) {
  console.warn("UNLOAD", e, moment().calendar());
};
window.onhashchange = function(e) {
  console.warn("HASHCHANGE", e, moment().calendar());
};
window.onpopstate = function(e) {
  console.warn("POPSTATE", e, moment().calendar());
};*/



// WEBPACK FOOTER //
// ./dev/src/magic.js